import type { ProColumns } from '@ant-design/pro-components'
import type { AccountDisplay } from '@super-mega/server/contracts/profile'
import { CREATED_AT_SORT_DIRECTIONS } from '@/const/list.ts'
import { RANGE_PRESETS } from '@/const/range-presets.ts'
import type { useMemberCreatorOptions } from '@/features/access/hooks/use-member-creator-options.ts'
import { UserAvatarName } from '@/features/profile/index.ts'
import {
  getCreatedAtSearch,
  getDateRangeFormValue,
  getTableSortOrder,
  type DateRangeFormValue
} from '@/utils/list-query.ts'
import { proRemoteSearch } from '@/utils/pro-select-search.ts'

type AuditSearch = {
  creatorMemberId?: number
  createdFrom?: string
  createdTo?: string
  sortField?: string
  sortOrder?: 'asc' | 'desc'
}
export type AuditFormValues = { creatorMemberId?: number; createdAtRange?: DateRangeFormValue }
export function getAuditFormValues(search: AuditSearch): AuditFormValues {
  return {
    creatorMemberId: search.creatorMemberId,
    createdAtRange: getDateRangeFormValue(search.createdFrom, search.createdTo)
  }
}
export function getAuditSearch(values: AuditFormValues) {
  return { creatorMemberId: values.creatorMemberId, ...getCreatedAtSearch(values.createdAtRange) }
}
export function auditedListColumns<T extends { creator: AccountDisplay; createdAt: Date }>({
  search,
  memberCreator,
  creatorWidth = '10rem',
  createdAtWidth = '12rem'
}: {
  search: AuditSearch
  memberCreator: ReturnType<typeof useMemberCreatorOptions>
  creatorWidth?: string
  createdAtWidth?: string
}): ProColumns<T>[] {
  return [
    {
      title: '创建人',
      dataIndex: 'creatorMemberId',
      hideInTable: true,
      valueType: 'select',
      fieldProps: {
        allowClear: true,
        options: memberCreator.options,
        loading: memberCreator.isLoading,
        ...proRemoteSearch(memberCreator.onSearch)
      }
    },
    {
      title: '创建时间',
      dataIndex: 'createdAtRange',
      hideInTable: true,
      fieldProps: { presets: RANGE_PRESETS },
      valueType: 'dateRange'
    },
    {
      title: '创建人',
      key: 'creator',
      search: false,
      width: creatorWidth,
      render: (_, row) => <UserAvatarName avatar={row.creator.avatar} name={row.creator.name} size={28} />
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      search: false,
      valueType: 'dateTime',
      width: createdAtWidth,
      sorter: true,
      sortDirections: CREATED_AT_SORT_DIRECTIONS,
      sortOrder: getTableSortOrder(search.sortOrder, search.sortField === 'createdAt')
    }
  ]
}
